import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

const TableCellRight = styled(TableCell)({ textAlign: 'right' });

export default TableCellRight;
